module.exports = __webpack_public_path__ + "img/front-arrow-white.e6b27ea9.svg";